<template>
<b-row class="mb-2">
  <b-col lg="3">
    <div class="form-group">
      <label class="form-control-label">{{$t('views.application.form.subdomain')}}:</label>
      <input v-model.lazy="filters.subdomain" v-debounce="delay" class="form-control" type="text" placeholder="">
    </div>
  </b-col>
  <b-col lg="3">
    <div class="form-group">
      <label>{{$t('views.application.form.domain')}}: </label>
      <model-select name="document_template" :options="domainOptions" v-model.lazy="filters.domain" >
      </model-select>
    </div>
  </b-col>
  <b-col lg="3">
    <div class="form-group">
      <label class="form-control-label">{{ $t('views.application.form.idUserData') }}:</label><br>
      <base-select-input
        v-model="filters.idUserData"
        :search-callback="userDataSearchCallback"
        :display-values="['fullName', 'firmname1']"
        :query-param="'userdata'"
        :is-auto-complete-mode="$store.getters['configuration/enableAutoCompleteForUserData']"
      ></base-select-input>
    </div>
  </b-col>
  <b-col cols="12" lg="3">
    <div class="form-group">
      <label class="form-control-label">{{ $t('views.application.list.blockStatus') }}:</label>
      <b-form-group>
        <b-form-radio-group
          v-model="filters.savedBlockStatus"
          :options="radioOptionsBlocked"
          buttons
          button-variant="outline-primary"
          name="radios-btn-default"
        ></b-form-radio-group>
      </b-form-group>
    </div>
  </b-col>
  <b-col cols="12" lg="3">
    <div class="form-group">
      <label class="form-control-label">{{ $t('views.firm.list.filters.state') }}:</label>
      <b-form-group>
        <b-form-radio-group
          v-model="filters.state"
          :options="radioOptions"
          buttons
          button-variant="outline-primary"
          name="radios-btn-default"
        ></b-form-radio-group>
      </b-form-group>
    </div>
  </b-col>
</b-row>
</template>

<script>
import debounce from 'v-debounce'
import { ModelSelect } from 'vue-search-select'
import { mapGetters, mapActions } from 'vuex'
import addParamsToQuery from '@/utils/addParamsToQuery'
import ApiService from '@/utils/ApiService'
import BaseSelectInput from '@/components/BaseComponents/BaseSelectInput.vue'

export default {
  name: 'ApplicationFiltering',
  components: {
    BaseSelectInput,
    ModelSelect
  },
  data () {
    return {
      delay: 500,
      userDataOptions: [],
      radioOptions: [{ value: 1, text: this.$t('buttons.no') }, { value: 0, text: this.$t('buttons.yes') }],
      radioOptionsBlocked: [
        { value: '', text: this.$t('global.all') },
        { value: 0, text: this.$t('buttons.no') },
        { value: 1, text: this.$t('buttons.yes') }
      ],
      filters: this.$store.state.filters.applicationFilter
    }
  },
  computed: {
    ...mapGetters({
      domainOptions: 'application/getDomainOptions'
    })
  },
  watch: {
    filters: {
      deep: true,
      handler () {
        this.filter()
      }
    }
  },
  directives: {
    debounce
  },
  created () {
    this.fetchDomainOptions()
  },
  methods: {
    filter () {
      this.$store.state.filters.applicationFilterCurrentPage = 1
      let url = 'applications'
      let params = Object.assign({}, this.filters)
      this.getPage(addParamsToQuery(url, params))
    },
    clearFilter () {
      this.filters = Object.assign(this.filters, this.$store.state.filters.applicationFilterReference)
    },
    async userDataSearchCallback (params = {}) {
      let baseParams = { pagination: false, isCompany: 1 }
      Object.assign(baseParams, params)
      const response = await new ApiService('user_datas/list', baseParams).getResults()
      return response.items
    },
    ...mapActions({
      fetchDomainOptions: 'application/fetchDomainOptions'
    }),
    getPage (url) {
      this.$emit('getPage', url)
    }
  }
}
</script>

<style scoped>

</style>
